<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import Infobox from "../Infobox.svelte";
    import RadioBtn from "../form/RadioBtn.svelte";
    import ErrorBox from "../form/ErrorBox.svelte";
    import {entityStore, myStore} from "../../stores.js";

    const dispatch = createEventDispatcher();
    let submitted:Boolean = false;

    let validStep = null;
    const stepKey = "step4";
    export let disabledFields = true;
    /*
    function onSubmitBtnClicked(){
       dispatch('submitBtnClicked');
    }

     */

    function checkValidity(key){
        let steps =  $entityStore.steps;
        const index = steps.findIndex((s) => s.key == key)
        if(steps[index]){
            validStep = steps[index].valid; // !step.valid && step.touched;

            steps[index].touched = true;

            if(validStep){
                //open next accordion
                if(index < steps.length){
                    steps[index].expanded = false;
                    steps[index].isActive = false;
                    steps[index].disabled = false;

                    steps[index+1].disabled = false;
                    steps[index+1].isActive = true;
                    steps[index+1].expanded = true;


                }

            }else{
                console.log(":::invalid -> valid = ",validStep)
            }

            entityStore.update($entityStore => ({
                ...$entityStore,
                steps
            }));
        }
    }

    function validateCurrentStep(){
        submitted = true;
        //validateStep(stepKey);
        checkValidity(stepKey)

        console.log("steps after: ",$entityStore.steps);
    }


</script>
<!-- translation example: {$_('introText')}-->
<div class="step">
    <div class="section">
        <h3 class="title">1. Subvention pour les frais d’un·e coordinateur·trice pacte communal</h3>
        <Infobox customClass="mb-4">
            Dans les limites des crédits budgétaires disponibles, une subvention est allouée sur demande aux communes signataires du pacte communal pour les frais d’un·e coordinateur·trice pacte communal, qui est soit un·e fonctionnaire ou un·e employé·e communal·e, soit un·e coordinateur·trice pacte communal externe, pendant la durée de validité du pacte communal. La subvention pour les frais du·de la coordinateur·trice pacte communal est plafonnée à 30 000 euros par année et par commune.
        </Infobox>

        <h3 class="title">
            Souhaitez-vous faire une demande de subvention pour les frais d’un·e coordinateur·trice pacte communal pour la durée dudit pacte (maximum 6 ans) ?
        </h3>
        <div class="mb-5">
            <RadioBtn disabled={disabledFields} key="wantApplyCosts" type="yes" title="Oui" value="YES"  checked="{$myStore.data.step4.wantApplyCosts === 'YES'}" group="step4.wantApplyCosts"></RadioBtn>
            <RadioBtn disabled={disabledFields} key="wantApplyCosts" type="no" title="Non" value="NO"  checked="{$myStore.data.step4.wantApplyCosts === 'NO'}" group="step4.wantApplyCosts"></RadioBtn>
            <RadioBtn disabled={disabledFields} key="wantApplyCosts" type="neutral" title="Je ne sais pas" value="MAYBE"  checked="{$myStore.data.step4.wantApplyCosts === 'MAYBE'}" group="step4.wantApplyCosts"></RadioBtn>
        </div>

    </div>

    <div class="section">
        <h3 class="title">2. Subvention pour la mise en œuvre du pacte communal</h3>
        <Infobox customClass="mb-4">
            Dans les limites des crédits budgétaires disponibles, une subvention annuelle est allouée sur demande aux
            communes
            signataires du pacte communal pour couvrir les frais de mise en œuvre du pacte communal. Cette subvention
            est échelonnée comme suit :
            <ul>
                <li>3000 euros pour les communes dont les conseils communaux sont composés de sept, neuf ou onze
                    conseillers communaux,
                </li>
                <li>5000 euros pour les communes dont les conseils communaux sont composés de treize ou quinze
                    conseillers communaux et
                </li>
                <li>8000 euros pour les communes dont les conseils communaux sont composés d’au moins dix-sept
                    conseillers communaux.
                </li>
            </ul>
        </Infobox>

    </div>
    <div class="section">
        <h3 class="title">
            Souhaitez-vous faire une demande de subvention pour mise en œuvre du pacte communal pour la durée dudit pacte (maximum 6 ans) ?
        </h3>
        <div class="mb-5">
            <RadioBtn disabled={disabledFields} key="wantApplyCommunalPact" type="yes" title="Oui" value="1"  checked={$myStore.data.step4.wantApplyCommunalPact} group="step4.wantApplyCommunalPact"></RadioBtn>
            <RadioBtn disabled={disabledFields} key="wantApplyCommunalPact" type="no" title="Non" value="0" checked={$myStore.data.step4.wantApplyCommunalPact} group="step4.wantApplyCommunalPact"></RadioBtn>
        </div>
    </div>

    <div class="section no-line">
        <h3 class="title">3. Subvention annuelle pour les communes adhérentes au pacte communal</h3>
        <Infobox customClass="mb-4">
            Les communes signataires du pacte communal reçoivent automatiquement une subvention annuelle de 5 euros pour chaque résident·e de la commune et chaque travailleur·euse transfrontalier·ière dont le lieu de travail se trouve dans la commune et qui est adhérent·e au pacte citoyen au 31 décembre de l'année en cours. La subvention est versée à la commune au premier trimestre de l'année consécutive. Aucune demande de subvention n'est nécessaire.
        </Infobox>

    </div>
    {#if submitted && !validStep}
        <ErrorBox>Les champs avec un cadre rouge ne sont pas encore remplis.</ErrorBox>
    {/if}
    {#if !submitted || !validStep}
        <div class="step-validation-btn">
            <button disabled={disabledFields} class="mt-2 btn btn-brand submitBtn" on:click={validateCurrentStep}>continuer</button>

        </div>
    {/if}

</div>


<style lang="scss">

</style>
